// frontend/src/api/shipping.js
import { apiClient } from './index';

const shippingApi = {
  getAllRates: async () => {
    return await apiClient.get('/shipping/rates');
  },

  updateRate: async (rateData) => {
    // rateData: { state, default_price, lga_rates }
    return await apiClient.post('/shipping/rates', rateData);
  },

  calculateCost: async (state, lga) => {
    return await apiClient.post('/shipping/calculate', { state, lga });
  }
};

export { shippingApi };